import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

export interface SlidingBtnEvent {
  name: string;
  index: number;
  value?: string | number;
}

export interface SlidingBtnTab {
  label: string;
  value?: string | number;
  icon?: string;
}

type SlidingBtnInput = string | SlidingBtnTab;

@Component({
  selector: 'app-sliding-btn',
  imports: [CommonModule, TranslocoPipe, NgClass],
  templateUrl: './sliding-btn.html',
  styleUrl: './sliding-btn.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlidingBtn {
  active = signal<number>(0);
  activeInput = input<number | null>(null);

  changeActiveTab = output<SlidingBtnEvent>();

  styleClass = input('bg-[#EFF2FB]');

  tabs = input<SlidingBtnInput[]>([]);

  normalizedTabs = computed<SlidingBtnTab[]>(() =>
    this.tabs().map((tab) =>
      typeof tab === 'string' ? { label: tab, value: tab } : tab,
    ),
  );

  content = input<TemplateRef<any>>();

  constructor() {
    effect(() => {
      const inputValue = this.activeInput();
      if (inputValue !== null && inputValue !== undefined) {
        this.active.set(inputValue);
      }
    });
  }

  changeActive(index: number) {
    this.active.set(index);
    const tab = this.normalizedTabs()[index];
    this.changeActiveTab.emit({
      name: tab.label,
      value: tab.value,
      index,
    });
  }
}
